import { useEffect, useState } from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { baseURL } from '../../../Utils/constants/constant';
import { GetRequest } from '../../../Utils/hooks/ApiHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '../../../Utils/helpers/commonhelper';

export const QuotationDetailsCard = ({ dealData, dealId, headers, extras, customerId }) => {
    const navigate = useNavigate();
    const [quotationData, setQuotationData] = useState([]); // state for storing associated quotation
    // fetching associated quotation
    useEffect(() => {
        if (!dealId && !dealData?.id) return;
        (async () => {
            const res = await GetRequest(
                `${baseURL}/deals/fetchAssociatedQuotation/${dealId || dealData?.id}/${customerId}`,
                { headers },
                extras,
            );
            if (res?.status === "fail" || res.status !== "success") {
                return setQuotationData([]);
            }
            if (res?.status === "success") {
                setQuotationData(res?.data);
            }
        })();
    }, [dealId, dealData?.id]);

    return (
        <div
            style={{
                background: "#fff",
                borderRadius: "8px",
                border: "1px solid #e2e8f0",
                marginBottom: "0rem",
                maxHeight: "26.37rem",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            }}
        >
            {/* Header - Fixed & Styled */}
            <div
                className="d-flex justify-content-between align-items-center px-3 py-2"

            >
                <p className="mb-0 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>
                    Associated Quotations
                </p>
                <Button
                    type="button"
                    className="btn btn-default"
                    style={{
                        height: "33px",
                        display: "flex",
                        alignItems: "center",
                    }}
                    onClick={() =>
                        navigate("/createQuotation", {
                            state: {
                                contactId: dealData?.contact_id,
                                dealId: dealData?.id,
                            },
                        })
                    }
                >
                    <FontAwesomeIcon icon={faPlus} /> Add
                </Button>
            </div>

            {/* Scrollable Content */}
            <div
                className="listStyleForContact"
                style={{
                    overflowY: "auto",
                    flex: 1,
                    backgroundColor: "#fff"
                }}
            >
                {quotationData && quotationData.length > 0 ? (
                    quotationData.map((item, index) => (
                        <div
                            key={index}
                            style={{
                                borderBottom: "1px solid #f1f5f9",
                                padding: "16px",
                                transition: "background 0.2s"
                            }}
                            className="quotation-item-row"
                        >

                            <div className="mb-3">
                                <span style={labelStyle}>Description</span>
                                {item?.description?.length > 50 ? (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id={`t-${index}`}>{item.description}</Tooltip>}
                                    >
                                        <p className="mb-0 fw-medium text-dark" style={{ fontSize: "13px", cursor: "help" }}>
                                            {item.description.substring(0, 50)}...
                                        </p>
                                    </OverlayTrigger>
                                ) : (
                                    <p className="mb-0 fw-medium text-dark" style={{ fontSize: "13px" }}>
                                        {item?.description || "No description provided"}
                                    </p>
                                )}
                            </div>


                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "1.2fr 1fr 1fr",
                                gap: "16px 12px"
                            }}>
                                <div onClick={() => navigate(`/detailquotation/${Number(item?.quotation_id)}`, { state: { key2: false } })} style={{ cursor: 'pointer' }}>
                                    <span style={labelStyle}>Quote No</span>
                                    <p className="mb-0 fw-bold" style={{ fontSize: "13px", color: "#0099ff", textDecoration: "underline" }}>
                                        {item?.quotation_number}
                                    </p>
                                </div>
                                <div>
                                    <span style={labelStyle}>Date</span>
                                    <p className="mb-0 text-dark" style={{ fontSize: "13px" }}>
                                        {formatDate(item?.quotation_date)}
                                    </p>
                                </div>
                                <div>
                                    <span style={labelStyle}>Status</span>
                                    <span className="badge" style={{
                                        fontSize: "10px",
                                        backgroundColor: item?.quotation_status === 'Approved' ? '#ecfdf5' : '#f1f5f9',
                                        color: item?.quotation_status === 'Approved' ? '#059669' : '#64748b',
                                        border: `1px solid ${item?.quotation_status === 'Approved' ? '#10b98133' : '#e2e8f0'}`
                                    }}>
                                        {item?.quotation_status?.toUpperCase()}
                                    </span>
                                </div>
                                <div>
                                    <span style={labelStyle}>Total Amount</span>
                                    <p className="mb-0 fw-bold text-dark" style={{ fontSize: "13px" }}>
                                        ₹{item?.total_amount}
                                    </p>
                                </div>
                                <div>
                                    <span style={labelStyle}>Valid Till</span>
                                    <p className="mb-0 text-secondary" style={{ fontSize: "13px" }}>
                                        {formatDate(item?.expiry_date)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center py-5">
                        <p className="text-muted small mb-0">No active quotations found</p>
                    </div>
                )}
            </div>
        </div>

    )
}

const labelStyle = {
    fontSize: "12px",
    fontWeight: "400",
    color: "#94a3b8",
    display: "block",
    marginBottom: "2px"
};